import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  rolesRecords: [],
  EmployeeRecords: null,
  employeeRecordById: null,
  totalPages: 0,
  currentPage: null,
};

export const EmployeesSlice = createSlice({
  name: "employees",
  initialState,
  reducers: {
    getRolesRecords: (state, action) => {
      state.rolesRecords = action.payload;
    },
    getEmployeeRecords: (state, action) => {
      state.EmployeeRecords = action.payload.data;
      state.totalPages = action.payload.totalPages;
    },
    setEmployeeDetailsById: (state, action) => {
      state.employeeRecordById = action.payload;
    },
    resetEmployeeDetailsById: (state) => {
      state.employeeRecordById = null;
    },
    setCurrentPage: (state) => {
      state.currentPage = 1;
    },
  },
});

export const {
  getRolesRecords,
  getEmployeeRecords,
  setEmployeeDetailsById,
  resetEmployeeDetailsById,
  setCurrentPage,
} = EmployeesSlice.actions;

export default EmployeesSlice.reducer;
